import { render, staticRenderFns } from "./dealState.vue?vue&type=template&id=53f6a540"
import script from "./dealState.vue?vue&type=script&lang=js"
export * from "./dealState.vue?vue&type=script&lang=js"
import style0 from "./dealState.vue?vue&type=style&index=0&id=53f6a540&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports